import React from 'react';
import '../styles/terms.css';

function TermsConditions() {
  return (
    <div className="terms-content">
      <div className="terms-section">
        <h2>1. Дефиниции и Терминология</h2>
        <p>
          <strong>1.1.</strong> В настоящите Условия за ползване ("Условията") следните термини имат посочените значения:
        </p>
        <ul>
          <li><strong>"Платформа"</strong> означава съвкупността от софтуерни решения, уеб интерфейси, сървъри и свързани услуги, предоставяни от Доставчика;</li>
          <li><strong>"Потребител"</strong> означава всяко физическо или юридическо лице, което използва Платформата;</li>
          <li><strong>"Съдържание"</strong> означава всякакви текстове, изображения, видео материали, аудио файлове, документи и други цифрови материали;</li>
          <li><strong>"Доставчик"</strong> означава оператора на Платформата;</li>
          <li><strong>"Услуга"</strong> означава предоставянето на техническа инфраструктура за създаване и хостинг на уеб сайтове;</li>
        </ul>
        <p>
          <strong>1.2.</strong> Настоящите Условия представляват изчерпателно споразумение между Потребителя и Доставчика и заменят всички предходни споразумения, преговори и заявления по отношение на предмета на регулиране.
        </p>
      </div>

      <div className="terms-section">
        <h2>2. Предмет и Обхват на Услугата</h2>
        <p>
          <strong>2.1.</strong> Доставчикът предоставя на Потребителя достъп до Платформа за създаване на персонализирани уеб сайтове за сватбени събития чрез автоматизирани инструменти и предварително дефинирани шаблони.
        </p>
        <p>
          <strong>2.2.</strong> Услугата включва, но не се ограничава до: техническа инфраструктура за хостинг, инструменти за редактиране на съдържание, система за управление на домейни и поддръжка на основни функционалности.
        </p>
        <p>
          <strong>2.3.</strong> Доставчикът не предоставя консултации по съдържание, дизайн услуги, правни съвети или гаранции за съответствие с регулаторни изисквания.
        </p>
      </div>

      <div className="terms-section">
        <h2>3. Задължения и Отговорности на Потребителя</h2>
        <p>
          <strong>3.1.</strong> Потребителят носи изключителна и неделима отговорност за цялото съдържание, което качва, публикува, съхранява или по друг начин предоставя чрез Платформата.
        </p>
        <p>
          <strong>3.2.</strong> Потребителят гарантира и декларира, че:
        </p>
        <ul>
          <li>Притежава всички необходими права върху използваното съдържание или е получил законно разрешение за използването му;</li>
          <li>Съдържанието не нарушава авторски права, търговски марки, патенти или други права на интелектуална собственост;</li>
          <li>Съдържанието не съдържа клеветнически, обидни, дискриминационни или незаконни материали;</li>
          <li>Съдържанието не нарушава приложимото законодателство на Република България и Европейския съюз;</li>
          <li>Съдържанието не застрашава сигурността на системата или други потребители;</li>
        </ul>
        <p>
          <strong>3.3.</strong> Потребителят се задължава да обезщети Доставчика за всякакви претенции, искове, щети, разходи и хонорари, произтичащи от нарушение на гаранциите по т. 3.2.
        </p>
      </div>

      <div className="terms-section">
        <h2>4. Категорично Ограничение на Отговорността на Доставчика</h2>
        <p>
          <strong>4.1.</strong> ДОСТАВЧИКЪТ НЕ НОСИ НИКАКВА ОТГОВОРНОСТ, ВКЛЮЧИТЕЛНО НО НЕ САМО, ЗА:
        </p>
        <ul>
          <li>Съдържанието, качено, създадено или публикувано от Потребителите;</li>
          <li>Нарушения на авторски права, търговски марки или други права на интелектуална собственост от страна на Потребителите;</li>
          <li>Неточности, грешки, пропуски или неактуалност в предоставената от Потребителите информация;</li>
          <li>Преки, непреки, случайни, специални, наказателни или последващи щети;</li>
          <li>Загуба на печалби, приходи, данни или използване на Услугата;</li>
          <li>Прекъсвания в работата на Услугата или технически неизправности;</li>
          <li>Неправомерен достъп до или промяна на съдържанието от трети лица;</li>
          <li>Вирусни атаки, злонамерен софтуер или други кибер запласи;</li>
          <li>Действия или бездействие на трети лица;</li>
          <li>Форс-мажорни обстоятелства;</li>
        </ul>
        <p>
          <strong>4.2.</strong> Доставчикът действа единствено като доставчик на техническа инфраструктура и не извършва модерация, преглед или контрол върху съдържанието, създавано от Потребителите.
        </p>
      </div>

      <div className="terms-section">
        <h2>5. Изричен Отказ от Отговорност за Потребителско Съдържание</h2>
        <p>
          <strong>5.1.</strong> Доставчикът категорично отказва всякаква отговорност за съдържанието, създадено, качено или публикувано от Потребителите, включително но не само за:
        </p>
        <ul>
          <li>Истинността, точността, пълнотата или актуалността на информацията;</li>
          <li>Съответствието със законодателството или етичните норми;</li>
          <li>Нарушенията на права на трети лица;</li>
          <li>Потенциални щети или вреди, причинени на трети лица;</li>
          <li>Последствията от публикуването или разпространението на съдържанието;</li>
        </ul>
        <p>
          <strong>5.2.</strong> Потребителите признават и се съгласяват, че използват Платформата изцяло на собствен риск и отговорност.
        </p>
      </div>

      <div className="terms-section">
        <h2>6. Забранени Действия и Съдържание</h2>
        <p>
          <strong>6.1.</strong> Потребителите се задължават да не предприемат действия или не качват съдържание, което:
        </p>
        <ul>
          <li>Нарушава авторски права, патенти, търговски марки или други права на интелектуална собственост;</li>
          <li>Съдържа клеветнически, обидни, заплашителни, дискриминационни или незаконни материали;</li>
          <li>Представлява спам, несъответна реклама или мошеннически материали;</li>
          <li>Застрашава сигурността, стабилността или функционалността на системата;</li>
          <li>Съдържа вредоносен код, вируси или други деструктивни елементи;</li>
          <li>Нарушава личната неприкосновеност или достойнство на трети лица;</li>
          <li>Противоречи на обществената морал или добрите нравствени принципи;</li>
          <li>Може да бъде квалифицирано като подбуждане към насилие или омраза;</li>
        </ul>
        <p>
          <strong>6.2.</strong> Нарушенията на посочените забрани могат да доведат до незабавно прекратяване на достъпа до Услугата без предварително уведомление.
        </p>
      </div>

      <div className="terms-section">
        <h2>7. Права и Правомощия на Доставчика</h2>
        <p>
          <strong>7.1.</strong> Доставчикът си запазва неограниченото право, по своя изключителна преценка и без задължение за обосновка, да:
        </p>
        <ul>
          <li>Премахва съдържание, което счита за неподходящо или нарушаващо настоящите Условия;</li>
          <li>Временно или трайно прекратява достъпа до Услугата на всеки Потребител;</li>
          <li>Модифицира, допълва или изменя условията за ползване с едностранно уведомление;</li>
          <li>Прекратява предоставянето на Услугата по всяко време без предварително уведомление;</li>
          <li>Ограничава функционалностите на Платформата или въвежда допълнителни условия;</li>
          <li>Прехвърля правата и задълженията си по настоящите Условия на трети лица;</li>
        </ul>
        <p>
          <strong>7.2.</strong> Упражняването на правата по т. 7.1. не поражда отговорност на Доставчика към Потребителя.
        </p>
      </div>

      <div className="terms-section">
        <h2>8. Гаранции и Изричен Отказ от Гаранции</h2>
        <p>
          <strong>8.1.</strong> Доставчикът предоставя Услугата в състоянието "както е" ("AS IS") и "както е налична" ("AS AVAILABLE") без каквито и да било гаранции.
        </p>
        <p>
          <strong>8.2.</strong> Доставчикът категорично отказва всякакви гаранции, изрични или подразбиращи се, включително но не само за:
        </p>
        <ul>
          <li>Непрекъснатост и безпроблемност на Услугата;</li>
          <li>Отсъствие на грешки, дефекти или уязвимости в системата;</li>
          <li>Сигурност и защита на данните;</li>
          <li>Съвместимост със всички операционни системи, браузъри или устройства;</li>
          <li>Качество, функционалност или производителност на генерираните уеб сайтове;</li>
          <li>Постигане на конкретни резултати или цели;</li>
          <li>Търговска годност или пригодност за определена цел;</li>
        </ul>
        <p>
          <strong>8.3.</strong> Потребителят изрично признава и се съгласява, че използва Услугата на собствен риск.
        </p>
      </div>

      <div className="terms-section">
        <h2>9. Ограничения на Отговорността и Обезщетение</h2>
        <p>
          <strong>9.1.</strong> В никакъв случай общата отговорност на Доставчика към Потребителя не може да надхвърли сумата, платена от Потребителя за Услугата през последните дванадесет месеца.
        </p>
        <p>
          <strong>9.2.</strong> Доставчикът не носи отговорност за непреки, случайни, специални, наказателни или последващи щети, независимо дали е бил уведомен за възможността от тяхното възникване.
        </p>
        <p>
          <strong>9.3.</strong> Потребителят се задължава да обезщети и предпази Доставчика от всякакви претенции, искове, щети, разходи и хонорари, произтичащи от или свързани с използването на Услугата.
        </p>
      </div>

      <div className="terms-section">
        <h2>10. Интелектуална Собственост</h2>
        <p>
          <strong>10.1.</strong> Всички права на интелектуална собственост върху Платформата, включително но не само авторски права, патенти, търговски марки и ноу-хау, принадлежат на Доставчика или неговите лицензодатели.
        </p>
        <p>
          <strong>10.2.</strong> Потребителят получава ограничено, неизключително, непрехвърляемо право да използва Платформата единствено в съответствие с настоящите Условия.
        </p>
        <p>
          <strong>10.3.</strong> Потребителят запазва правата си върху създаденото от него съдържание, но предоставя на Доставчика неизключителна лицензия за използването му в рамките на предоставянето на Услугата.
        </p>
      </div>

      <div className="terms-section">
        <h2>11. Защита на Личните Данни</h2>
        <p>
          <strong>11.1.</strong> Обработката на личните данни се осъществява в съответствие с приложимото законодателство и Политиката за поверителност на Доставчика.
        </p>
        <p>
          <strong>11.2.</strong> Потребителят е единствено отговорен за защитата на своите данни за достъп и носи отговорност за всички действия, извършени чрез неговия акаунт.
        </p>
        <p>
          <strong>11.3.</strong> Доставчикът не носи отговорност за неправомерен достъп до данните на Потребителя, дължащ се на нарушение на сигурността от страна на Потребителя.
        </p>
      </div>

      <div className="terms-section">
        <h2>12. Прекратяване на Отношенията</h2>
        <p>
          <strong>12.1.</strong> Потребителят може да прекрати използването на Услугата по всяко време чрез деактивиране на своя акаунт.
        </p>
        <p>
          <strong>12.2.</strong> Доставчикът може да прекрати предоставянето на Услугата незабавно при нарушение на настоящите Условия от страна на Потребителя.
        </p>
        <p>
          <strong>12.3.</strong> При прекратяване на отношенията, Доставчикът може да изтрие цялото съдържание и данни на Потребителя без предварително уведомление.
        </p>
      </div>

      <div className="terms-section">
        <h2>13. Изменения на Условията</h2>
        <p>
          <strong>13.1.</strong> Доставчикът си запазва правото да изменя настоящите Условия по всяко време по своя изключителна преценка.
        </p>
        <p>
          <strong>13.2.</strong> Измененията влизат в сила от момента на публикуването им на уеб сайта на Доставчика.
        </p>
        <p>
          <strong>13.3.</strong> Продължаването на използването на Услугата след публикуването на измененията се счита за безусловно приемане на новите условия.
        </p>
      </div>

      <div className="terms-section">
        <h2>14. Приложимо Право и Разрешаване на Спорове</h2>
        <p>
          <strong>14.1.</strong> Настоящите Условия се уреждат от и се тълкуват съгласно българското право.
        </p>
        <p>
          <strong>14.2.</strong> Всички спорове, произтичащи от или свързани с настоящите Условия, подлежат на изключителната юрисдикция на българските съдилища.
        </p>
        <p>
          <strong>14.3.</strong> В случай на противоречие между различните езикови версии на Условията, българската версия има предимство.
        </p>
      </div>

      <div className="terms-section">
        <h2>15. Заключителни Разпоредби</h2>
        <p>
          <strong>15.1.</strong> Ако някоя разпоредба от настоящите Условия бъде призната за невалидна или неприложима, останалите разпоредби запазват своята сила.
        </p>
        <p>
          <strong>15.2.</strong> Неупражняването на право от страна на Доставчика не се тълкува като отказ от това право.
        </p>
        <p>
          <strong>15.3.</strong> Настоящите Условия не създават партньорство, съдружие или отношения на представителство между страните.
        </p>
      </div>

      <div className="terms-section">
        <h2>16. Контактна Информация</h2>
        <p>
          <strong>16.1.</strong> За въпроси, свързани с настоящите Условия за ползване или предоставяните услуги, можете да се свържете с Доставчика чрез следните канали за комуникация:
        </p>
        <p>
          <strong>Официален телефон за връзка:</strong> +359 899 103 537<br/>
          <strong>Електронна поща:</strong> rdtechnsolutions@gmail.com<br/>
        </p>
      </div>

      <div className="terms-footer">
        <p>
          <strong>Версия на документа:</strong> 2.1<br/>
          <strong>Дата на последна актуализация:</strong> 13. Юли 2025 г.<br/>
          <strong>Дата на влизане в сила:</strong> 13. Юли 2025 г.
        </p>
        <p className="terms-footer-note">
          Чрез използването на предоставените услуги, Потребителят неоспоримо потвърждава,
          че е прочел, разбрал и безусловно приема всички разпоредби на настоящите Условия
          за ползване в тяхната актуална редакция.
        </p>
      </div>
    </div>
  );
}

export default TermsConditions;
